// extracted by mini-css-extract-plugin
export default {"empty-text":"pulEQREDCb8JHkanNbF6"};